<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hAs1Oy/tc-custom/9781555848750.jpg?1703330638299" alt="This image is the cover for the book T.H.U.G. L.I.F.E."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">T.H.U.G. L.I.F.E.
      </h1>
      <p class="bookDescription body article font2">
        <b>A street lit novel that’s “a visceral and strikingly real portrayal of gang life in Los Angeles” from the author of the bestselling memoir <i>Monster</i> (<i>Publishers Weekly</i>).</b><br/><br/><i>T.H.U.G. L.I.F.E.</i> is a vicious, heart-wrenching and true-to-life novel about an LA gang member that masterfully captures the violence and depravity of gang life. Shakur’s protagonist is Lapeace, the leader of the Eight Tray Crips gang in South Central Los Angeles. In a deadly gunfight with Anyhow, a Blood and Lapeace’s rival since childhood, eight innocent civilians are killed. Anyhow is captured. Lapeace becomes a fugitive and he must hide out in the home of his girlfriend, Tashima, a hip-hop mogul as a pair of crooked LA detectives, John Sweeney and Jesse Mendoza, attempt to track him down.<br/><br/><br/>This novel was written from the confines of Shakur’s jail cell, and the authenticity of its street scenes—the relentlessness of violence, the do-or-die attitude of each side of the gang war, the sheer joy in the killing—is a testament to the hell that has been a majority of Shakur’s life. With <i>T.H.U.G. L.I.F.E.</i>, Shakur delivers a powerful and gripping story about the terror of gang life and one man’s attempt to free himself.<br/><br/>“Shakur is better than anyone else in the street lit game at making his characters feel like real people . . . This gang life novel is the real deal.”—<i>Publishers Weekly</i><br/><br/>“This fascinating novel reflects the raw violence and moral ambiguities of street gangs and the cops who police them.”—<i>Booklist</i><br/><br/>“<i>T.H.U.G. L.I.F.E.</i> deftly weaves together the extensive and complex histories of its characters with their present struggles.”—<i>Chicago Defender</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sanyika Shakur
      </h2>
      
      <p class="authorDescription body article">Sanyika Shakur, also known by his former street moniker Monster, is a former member of the Los Angeles gang the Eight Tray Gangster Crips. He got his nickname as a 13-year-old gang member when he beat and stomped a robbery victim until he was disfigured.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f6756ba0